<template lang="pug">
  .easy-week-component
    .grid-container(:style="gridCss")
      .grid-row-header.grid-column-header.plate
        span {{plate}}
      .grid-column-header.shift-header(v-for="shift in shifts" :style="{'grid-row': shift.name + shift.id}")
        b {{shift.name}}
        span {{shift.start}}
        span {{shift.end}}
      template(v-for="(dayShift, idx) in doDays")
        .grid-row-header
          span {{dayShift.name}} {{dayShift.date}}
        .bracket(v-for="shift in dayShift.shifts"  :style="{'grid-row': shift.name + shift.id, 'grid-column': idx + 2, 'background-color': getBackgroundColor(shift)}")
          .bracket-reservations(v-if="shift.reservations.length")
            .bracket-reservation(
              v-for="res in shift.reservations" :key="res.reservation_id"
              :style="{'background-color': dayShift.color || getColor(res, shift) || '#fafafa'}"
              :class="res.status.toLowerCase()"
            )
              p(@click="getDetails(res)")
                template(v-if="daysToShow <= 21")
                  router-link(:to="{name:'driver', params:{id:res.driver_id}}" )
                    b DR{{res.driver_id}}
                  br
                  router-link(:to="{name:'reservation', params:{id:res.reservation_id}}")
                    span.reservation-id R{{res.reservation_id}}
    .details-container(v-if="details || loadingDetails")
      button.close-button(aria-label="Close alert" type="button" @click="clearDetails")
        span(aria-hidden="true") &times;
      LoadingSpinner(v-if="loadingDetails")
      .row(v-else-if="details")
        // see line 154
        //.columns.small-12.large-6(v-if="details.driver")
        //  Driver(type="driver-card" :item="details.driver")
        .columns.small-12(v-if="details.reservation")
          h4 reservation details
          Reservation(type="listing" :item="details.reservation")
</template>

<script>
  import moment from "moment"
  import Tooltip from 'components/structure/foundation/Tooltip'
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice"
  import LoadingSpinner from "../structure/LoadingSpinner"
  import Driver from "../backoffice/Driver"
  import Reservation from "../backoffice/Reservation"

  export default {
    name: "EasyWeeks",
    components: {Driver, LoadingSpinner, Tooltip, Reservation},
    props: {
      plate: String,
      shifts: Array,
      reservations: Array,
      daysToShow: Number,
    },
    data() {
      return {
        details: null,
        loadingDetails: false
      }
    },
    computed: {
      gridCss() {
        const repeatForShifts = () => {
          const arr = []
          this.shifts.forEach(s => {
            arr.push(`[row-${s.name + s.id}] '${s.name + s.id}' max-content`)
          })
          return arr.join(' ')
        }

        return {
          'grid': `[row-header] 'header' max-content ` + repeatForShifts(),
          'grid-auto-columns': 'minmax(min(5em, 100%), 1fr)',
        }
      },
      days() {
        const arr = []
        for (let n = 0; n < this.daysToShow; n++) {
          arr.push(moment().isoWeekday(n + 2).format('ddd'))
        }
        return arr
      },
      doDays() {
        const arr = []

        const parseTime = (time) => {
          const t = moment(time, 'HH:mm')
          return {
            hour: t.hours(),
            minutes: t.minutes()
          }
        }

        for (let n = 0; n < this.daysToShow; n++) {
          const veramenteDay = moment().isoWeekday(n + moment().isoWeekday()).startOf('minute')
          const day = {
            name: veramenteDay.format('ddd'),
            date: veramenteDay.format('DD'),
            shifts: []
          }

          this.shifts.forEach(shift => {
            const obj = {}
            obj.reservations = this.reservations.filter(r => {
              const t1 = parseTime(shift.start)
              const sStart = veramenteDay.clone().hour(t1.hour).minutes(t1.minutes)
              const sEnd = sStart.clone().add(shift.duration, "minutes")
              const rStart = moment(r.start)
              const rEnd = moment(r.end)
              const isContained = sStart.isSameOrBefore(rStart) && sEnd.isSameOrAfter(rEnd)
              const hovers = rStart.isSameOrBefore(sStart) && rEnd.isSameOrAfter(sEnd)
              const startsIn = (rStart.isSameOrAfter(sStart) && rStart.isBefore(sEnd))
              const endsIn = (rEnd.isAfter(sStart) && rEnd.isSameOrBefore(sEnd))
              // isContained is thwe OG one for autoshift
              return isContained || hovers || startsIn || endsIn
            })

            obj.id = (shift.start + shift.end).replaceAll(':', '')
            obj.name = shift.name

            day.shifts.push(obj)

          })
          arr.push(day)
        }
        return arr
      },
    },
    methods: {
      displayDay(day) {
        const m = moment(day)
        return m.format("dddd")
      },
      getBackgroundColor(shift) {
        let id = shift.id
        let name = shift.name
        return '#eaeaea'

        const i = id.slice(0, 2)
        if (i < 8) {
          return '#3680c5'
        } else if (i > 18) {
          return '#3680c5'
        } else {
          return 'yellow'
        }
      },
      getColor(reservation) {
        if (reservation.memo) {
          let c = reservation.memo.split(' ')[0]
          if(c[0] === "#"){
            return c
          }
          switch (c) {
            case "DAY":
              return 'yellow'
            case "NIGHT":
              return '#3680c5'
          }
        }
        return '#03fc84'
      },
      getDriver(id) {
        return new Promise(resolve => {
          KeplerBackofficeSdk.drivers.select(id).get(data => {
            resolve(data)
          })
        })
      },
      getReservation(id) {
        return new Promise(resolve => {
          KeplerBackofficeSdk.reservations.select(id).get(data => {
            resolve(data)
          })
        })
      },
      getDetails(res) {
        this.loadingDetails = true
        Promise.all([
          this.getReservation(res.reservation_id),
          // optionally get driver info
          // this.getDriver(res.driver_id)
        ]).then(r => {
          this.details = {
            reservation: r[0],
            driver: r[1]
          }
        }).finally(() => {
          this.loadingDetails = false
        })
      },
      clearDetails() {
        this.details = null
        this.loadingDetails = false
      }
    }
  }
</script>

<style lang="sass">
  .easy-week-component
    .details-container
      margin-top: 1em
      padding-top: 1em
      padding-left: 1em
      position: relative
      background-color: #f2f2f2
      border-radius: 6px
    .grid-container
      display: grid
      gap: 3px
      //grid-template-columns: max-content

      .headers
        font-weight: bold

      .bracket-reservations
        display: flex
        flex-flow: column nowrap

        .bracket-reservation
          position: relative
          border-radius: 4px
          background: #fff
          margin: 0.25em
          width: calc(100% - 0.5em)
          text-align: center
          color: black
          display: flex
          overflow: hidden

          .reservation-id
            font-size: .8em

          & a
            color: #555

            &:hover
              color: #333

          & > p
            font-weight: 400
            background: #ffffffaa
            padding: 0 3px
            margin: 6px
            width: 100%
            border-radius: 2px
            z-index: 1
            text-align: start

          &:after
            position: absolute
            content: ''
            width: 0
            height: 0
            border-style: solid
            border-width: 0 1.5em 1.5em 0
            border-color: transparent red transparent transparent
            right: 0

          &.confirmed:after
            border-color: transparent #57b400 transparent transparent

          &.planned:after
            border-color: transparent #ffc458 transparent transparent

          &.started:after
            border-color: transparent blue transparent transparent

      .empty-bracket
        visibility: hidden

      .grid-column-header
        grid-column: header
        padding: .25em
        align-self: center

      .grid-row-header
        grid-row: header
        justify-self: center
        align-self: center
        color: black

      .plate
        font-weight: bold
        font-size: 1.1em
        width: 100%

      .shift-header
        display: flex
        flex-direction: column
        align-items: flex-end
        margin-bottom: auto

        & > span
          font-size: .75rem
          font-weight: bold
          color: black

      .bracket
        //border-bottom: 1px solid #ccc
        //border-left: 1px solid #ccc
        background: #eaeaea

</style>



// WEBPACK FOOTER //
// EasyWeek.vue?694bac1f